module.exports = __webpack_public_path__ + "img/1723595407168-image.jpg.e70dc674.webp";